import type { RetailMicroTransferDescriptor, RetailWalletChallengeResponse } from "@solomon-apps/shared";

/** HTTP JSON and wallet-provider values are untrusted until their fields are checked. */
export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** Invalid JSON is malformed response data; transport and abort errors must still propagate. */
export async function readResponseJson(response: Response): Promise<unknown> {
    try {
        return await response.json();
    } catch (error) {
        if (error instanceof SyntaxError) return null;
        throw error;
    }
}

function isTransferDescriptor(value: unknown): value is RetailMicroTransferDescriptor {
    return (
        isRecord(value) &&
        typeof value.recipient === "string" &&
        (typeof value.lamports === "string" || typeof value.lamports === "number") &&
        typeof value.memo === "string"
    );
}

export function isWalletChallenge(value: unknown): value is RetailWalletChallengeResponse {
    return (
        isRecord(value) &&
        typeof value.nonce === "string" &&
        value.nonce.length > 0 &&
        typeof value.message === "string" &&
        value.message.length > 0 &&
        typeof value.expiresAt === "string" &&
        Number.isFinite(Date.parse(value.expiresAt)) &&
        (value.microTransfer === undefined || isTransferDescriptor(value.microTransfer))
    );
}
